module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/chevron_down.22be06f2.svg";